export const platforms = [
    {key: "SelectPlatform", name: "Select Platform"},
    {key: "AzureDevOps", name: "Azure DevOps"},
    {key: "BitBucket", name: "Bitbucket"},
    {key: "GitHub", name: "GitHub"}
]

export const defaultDropDownValues = {
    repositories: [{ID: 0, name: "Select Platform to get Repositories"}],
    developers: [{name: "Select Repository to see Developers", value: "RepoSelect"}]
}